import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UtilsService} from '../../core/utils/utils.service';
import {ActivatedRoute, Event, NavigationStart, Router} from '@angular/router';
import {MenuPlcSupplier} from './menu-plc-resolver.service';
import {PointDeLivraisonDTO} from '../../core/dtos/point-de-livraison-d-t-o';
import {MenuItem, SelectItem} from 'primeng/api';
import {PrintEffectifService, PrintEffectifSupplier} from '../../core/services/gestion-plc/print-effectif.service';
import {PrintCoutRevientPlatService} from '../../core/services/gestion-plc/print-cout-revient-plat.service';
import {Menu} from "primeng/menu";
import {RepasDTO} from "../../core/dtos/repas-dto";
import {ToastService} from "../../core/services/technique/toast.service";
import {StartPointCommandesClientsEnum} from "../../core/enums/start-point-commandes-clients-enum";
import {CommandesClientService} from "../../core/services/entities/commandes-client.service";
import DatesDetailsFromMenuDTO from "../../core/dtos/planification/dates-details-from-menu-dto";
import Week from "../../core/dtos/week-dto";
import {ConviveDTO} from "../../core/dtos/convive-dto";
import {MSG_KEY, MSG_SEVERITY} from "../../core/constants";
import {TypeEffectifEnum} from "../../core/enums/type-effectif-enum";
import RowEffectifsCommandesClientDTO from "../../core/dtos/planification/row-effectifs-commandes-client-dto";
import DetailEffectifCommandeClientDTO from "../../core/dtos/planification/detail-effectif-commande-client-dto";
import {DatePipe} from "@angular/common";
import ViewCommandesEffectifsDTO from "../../core/dtos/planification/views/view-commandes-effectifs-dto";
import {range, Subject, Subscription} from 'rxjs';
import {filter, map, switchMap, toArray} from 'rxjs/operators';

@Component({
  selector: 'yo-menu-plc',
  templateUrl: './menu-plc.component.html',
  styleUrls: ['./menu-plc.component.scss']
})
export class MenuPlcComponent implements OnInit, OnDestroy {

  subRouteData: Subscription;
  subMonthChange: Subscription;
  subHaveDataToPrint: Subscription;
  subRefreshViewCommandesEffectif: Subscription;
  subSilentRefreshView: Subscription;
  subSaveEffectivesCommandesClientsFromRow: Subscription;
  subSaveEffectivesCommandesClientsFromDetail: Subscription;
  subRowUpdated: Subscription;
  subDetailUpdated: Subscription;
  subSelectedCell: Subscription;
  subLoadView: Subscription;

  private loadViewTrigger$ = new Subject<void>();

  mplc: MenuPlcSupplier;
  localeFr;
  week: Week;
  modesSource: SelectItem[] = [
    {label: 'Prévision', value: TypeEffectifEnum.PREVISIONNEL},
    {label: 'Fabrication', value: TypeEffectifEnum.FABRICATION}
  ];

  modes: SelectItem[] = [
    {label: 'Prévision', value: TypeEffectifEnum.PREVISIONNEL},
    {label: 'Fabrication', value: TypeEffectifEnum.FABRICATION},
    {label: 'Facturation', value: TypeEffectifEnum.FACTURATION}
  ];
  modesFiltered: SelectItem[];

  startPoints: SelectItem[] = [
    {label: 'Point de livraison', value: StartPointCommandesClientsEnum.PLC},
    {label: 'Repas', value: StartPointCommandesClientsEnum.REPAS},
    {label: 'Prestation/Régime', value: StartPointCommandesClientsEnum.PRESTATION},
  ];
  StartPointCommandesClientsEnum = StartPointCommandesClientsEnum;

  selectedPlc: PointDeLivraisonDTO;
  selectedPlcListForDuplication: number[] = [];
  selectedRepas: RepasDTO;
  selectedPrestation: ConviveDTO;
  typeEffectifSelected: TypeEffectifEnum = TypeEffectifEnum.PREVISIONNEL;
  selectedStartPoint: StartPointCommandesClientsEnum = StartPointCommandesClientsEnum.PLC;
  selectedDate: Date = new Date();
  idSelected: number;
  codeSelected: string;

  datesCreationMenus: Date[];
  datesSaisieEffectifs: Date[];
  datesFacturation: Date[];
  disabledDays: number[];
  dateMin: Date;
  datesDetailsFromMenu: DatesDetailsFromMenuDTO;

  @ViewChild('printMenu') printMenu: Menu;

  itemCr = {
    icon: 'far fa-file-pdf',
    label: 'Calcul du coût de revient d\'un plat',
    command: () => this.openDialogPrintCoutRevientPlat(),
  };

  itemEffectifs = {
    icon: 'far fa-file-excel',
    label: `Effectifs`,
    command: () => this.openDialogPrintEffectifMenu(),
    disabled: true
  };

  itemEffectifsTotaux = {
    icon: 'far fa-file-excel',
    label: `Effectifs totaux`,
    command: () => this.openDialogPrintEffectifMenuTotaux()
  };

  itemEffectifsDetails = {
    icon: 'far fa-file-excel',
    label: `Effectifs avec détail des menus`,
    command: () => this.openDialogPrintEffectifDetailsMenu(),
    disabled: true
  };

  itemsPrintMenu: MenuItem[] = [
    this.itemCr,
    this.itemEffectifs,
    this.itemEffectifsTotaux,
    this.itemEffectifsDetails
  ];

  popupDuplicateEffectivesVisible: boolean = false;
  duplicateToPrevisionnel: boolean = false;
  duplicateToManufacturing: boolean = false;
  duplicateToBilling: boolean = false;

  //Flexibilité
  searchModeOption = 'contains';
  searchExprOption: any = 'libelle';
  startPoint: StartPointCommandesClientsEnum = StartPointCommandesClientsEnum.PLC;
  duplicateStartPoint: StartPointCommandesClientsEnum = StartPointCommandesClientsEnum.PLC;
  endPoint: StartPointCommandesClientsEnum;
  endPointPanel: StartPointCommandesClientsEnum[] = [];

  calendarOptions = {
    cellTemplate: 'cell',
    onOptionChanged: (e: any) => {
      if (e.name === 'currentDate') {
        this.updateDatesByMonth(e.value);
      }
    }
  };

  viewCommandesEffectifs: ViewCommandesEffectifsDTO;
  duplicateViewCommandesEffectifs: ViewCommandesEffectifsDTO;
  cols: Date[] = [];
  timer: any;
  inactivityTimer: any;
  private visibilityChangeHandler: () => void;
  private beforeUnloadHandler: (event: BeforeUnloadEvent) => void;
  private mouseMoveHandler: () => void;
  private keyPressHandler: () => void;

  rowsUpdated: RowEffectifsCommandesClientDTO[] = [];
  detailsUpdated: DetailEffectifCommandeClientDTO[] = [];

  loadingVisible: boolean = false;

  typeEffectifSource: TypeEffectifEnum = TypeEffectifEnum.PREVISIONNEL;
  typesEffectifTarget: TypeEffectifEnum[] = [TypeEffectifEnum.FABRICATION];

  selectedCell: RowEffectifsCommandesClientDTO;

  constructor(public utils: UtilsService, private route: ActivatedRoute,
              private cd: ChangeDetectorRef,
              private printEffectifService: PrintEffectifService,
              private printCrpService: PrintCoutRevientPlatService,
              private toastSvc: ToastService,
              private commandesClientSvc: CommandesClientService,
              private datePipe: DatePipe,
              private router: Router) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) this.saveEffectivesCommandesClients();
    });

    this.visibilityChangeHandler = () => {
      if (document.visibilityState != "visible") {
        this.saveEffectivesCommandesClients(true);
      }
    };
    document.addEventListener("visibilitychange", this.visibilityChangeHandler);

    this.beforeUnloadHandler = (event: BeforeUnloadEvent) => {
      this.saveEffectivesCommandesClients(true);
      event.returnValue = '';
    };
    window.addEventListener("beforeunload", this.beforeUnloadHandler);

    this.inactivityTime();
  }

  ngOnInit() {
    this.initHaveDataToPrintSubscription();
    this.menuMonthChangeSubscription();
    this.routeDataSubscription();
    this.refreshViewCommandeClientSubscription();
    this.silentRefreshViewSubscription();
    this.saveEffectifsCommandesClientsSubscription();
    this.rowUpdatedSubscription();
    this.detailUpdatedSubscription();
    this.selectedCellSubscription();
    this.initLoadViewSubscription();
    this.updateDatesBySelection(null);
    this.initEndPoint();
    this.initData();
  }

  ngOnDestroy() {
    this.utils.unsubscribe(this.subRouteData);
    this.utils.unsubscribe(this.subMonthChange);
    this.utils.unsubscribe(this.subHaveDataToPrint);
    this.utils.unsubscribe(this.subRefreshViewCommandesEffectif);
    this.utils.unsubscribe(this.subSilentRefreshView);
    this.utils.unsubscribe(this.subSaveEffectivesCommandesClientsFromRow);
    this.utils.unsubscribe(this.subSaveEffectivesCommandesClientsFromDetail);
    this.utils.unsubscribe(this.subRowUpdated);
    this.utils.unsubscribe(this.subDetailUpdated);
    this.utils.unsubscribe(this.subSelectedCell);
    this.utils.unsubscribe(this.subLoadView);

    document.removeEventListener("visibilitychange", this.visibilityChangeHandler);
    window.removeEventListener("beforeunload", this.beforeUnloadHandler);

    if (this.mouseMoveHandler) document.removeEventListener("mousemove", this.mouseMoveHandler);
    if (this.keyPressHandler) document.removeEventListener("keypress", this.keyPressHandler);
    clearTimeout(this.inactivityTimer);
  };

  routeDataSubscription = () => {
    this.subRouteData = this.route.data
      .subscribe((data: { menuPlcSupplier: MenuPlcSupplier }) => this.mplc = data.menuPlcSupplier);
  };

  selectedCellSubscription = () => {
    this.subSelectedCell = this.commandesClientSvc.selectedCell$
      .subscribe((data) => this.selectedCell = data);
  };

  /**
   * Subscription qui permet de rafraîchir les données du calendrier selon la date sélectionnée
   */
  menuMonthChangeSubscription = () => {
    this.subMonthChange = this.commandesClientSvc.menuMonthChange$.subscribe(item => {
      this.commandesClientSvc.getMonthDates(item[0], this.selectedDate, this.idSelected, this.startPoint)
        .subscribe(response => {
          if (response.one) this.initMenu(response.one, item[0], item[1]);
        })
    });
  };

  initData = () => {
    this.modesFiltered = this.modes.filter(mode => mode.value !== this.typeEffectifSource);
  }

  isDatesDisabled = () => this.codeSelected == null;

  isDisabled = () => this.codeSelected == null || this.viewCommandesEffectifs == null;

  /**
   * Méthode qui initialise les colonnes selon la date sélectionnée par l'utilisateur
   */
  initCols = () => {
    const joursDisponibles = this.datesDetailsFromMenu.joursDisponibles?.length
      ? this.datesDetailsFromMenu.joursDisponibles
      : [1, 2, 3, 4, 5, 6, 7];

    range(0, 7).pipe(
      map(offset => this.utils.addDaysToDate(this.week.weekMonday, offset)),
      filter(date => date <= this.week.weekSunday),
      filter(date => {
        const day = date.getDay() === 0 ? 7 : date.getDay();
        return joursDisponibles.includes(day);
      }),
      toArray(),
      map(dates => dates.sort((a, b) => a.getTime() - b.getTime()))
    )
      .subscribe(dates => this.cols = dates);
  };

  openDialogDuplicateEffectivesPrevisionnals = (): void => {
    this.saveEffectivesCommandesClients();

    this.popupDuplicateEffectivesVisible = true;
  }

  closeDialogDuplicateEffectivesPrevisionnals = (): void => {
    this.duplicateToManufacturing = false;
    this.duplicateToBilling = false;
    this.popupDuplicateEffectivesVisible = false;
  }

  /**
   * Méthode pour dupliquer les effectifs
   */
  duplicateEffectives = (): void => {
    if (this.viewCommandesEffectifs) {
      this.declareCodeSelected();

      this.commandesClientSvc.duplicateEffectifsCommandesClients(this.week.weekMonday, this.week.weekSunday, this.codeSelected,
        this.startPoint, this.endPoint, this.typeEffectifSource, this.typesEffectifTarget)
        .subscribe(response => {
          if (!this.utils.isNullOrEmpty(response) && !this.utils.isNullOrEmpty(response.one)) {
            this.commandesClientSvc.announceRefreshViewCommandesEffectif();
            this.closeDialogDuplicateEffectivesPrevisionnals();
            this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Effectif(s) dupliqué(s) avec succès`);
          } else {
            this.viewCommandesEffectifs = null;
            this.commandesClientSvc.announceViewCommandesEffectif(null);
          }
        });
    } else {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, `Veuillez sélectionner un point de livraison ayant un menu existant pour une période donnée`);
    }
  }

  /**
   * Subscription qui permet de rafraîchir la vue du planning des effectifs
   */
  refreshViewCommandeClientSubscription = () => {
    this.subRefreshViewCommandesEffectif = this.commandesClientSvc.refreshViewCommandesEffectif$
      .subscribe(() => {
        this.viewCommandesEffectifs = null;
        if (this.codeSelected) this.getViewEffectifCommandeClient();
      });
  }

  silentRefreshViewSubscription = () => {
    this.subSilentRefreshView = this.commandesClientSvc.silentRefreshView$
      .subscribe(() => this.loadViewSilently());
  }

  loadViewSilently = () => {
    this.loadingVisible = true;
    this.commandesClientSvc.loadViewCommandesEffectif(
      this.week.weekMonday, this.week.weekSunday, this.codeSelected,
      this.startPoint, this.endPoint, this.typeEffectifSelected
    ).subscribe(reloadResponse => {
      if (!this.utils.isNullOrEmpty(reloadResponse) && !this.utils.isNullOrEmpty(reloadResponse.one) && !reloadResponse.one.empty) {
        this.viewCommandesEffectifs = reloadResponse.one;
        this.duplicateViewCommandesEffectifs = JSON.parse(JSON.stringify(reloadResponse.one));
        this.commandesClientSvc.announceViewCommandesEffectif(this.viewCommandesEffectifs);
        this.commandesClientSvc.announceUpdatedViewCommandesEffectif(this.selectedCell, this.viewCommandesEffectifs);
      }
      this.loadingVisible = false;
    });
  }

  declareCodeSelected = () => {
    if (this.selectedPlc) {
      this.idSelected = this.selectedPlc.id;
      this.codeSelected = this.selectedPlc.code;
    } else if (this.selectedRepas) {
      this.commandesClientSvc.announceSelectedRepas(this.selectedRepas);
      this.idSelected = this.selectedRepas.id;
      this.codeSelected = this.selectedRepas.code;
    } else if (this.selectedPrestation) {
      this.idSelected = this.selectedPrestation.id;
      this.codeSelected = this.selectedPrestation.code;
    } else {
      this.idSelected = null;
      this.codeSelected = null;
    }
  }

  /**
   * Initialise la subscription switchMap pour les chargements de vue effectifs.
   * switchMap annule automatiquement toute requête précédente encore en vol,
   * éliminant les race conditions entre appels concurrents.
   */
  initLoadViewSubscription = () => {
    this.subLoadView = this.loadViewTrigger$.pipe(
      switchMap(() => {
        this.loadingVisible = true;
        this.commandesClientSvc.announceLoadingView(this.loadingVisible);
        return this.commandesClientSvc.loadViewCommandesEffectif(
          this.week.weekMonday, this.week.weekSunday, this.codeSelected,
          this.startPoint, this.endPoint, this.typeEffectifSelected
        );
      })
    ).subscribe(response => {
      if (!this.utils.isNullOrEmpty(response) && !this.utils.isNullOrEmpty(response.one) && !response.one.empty) {
        this.viewCommandesEffectifs = response.one;
        this.duplicateViewCommandesEffectifs = JSON.parse(JSON.stringify(response.one));
        this.commandesClientSvc.announceViewCommandesEffectif(this.viewCommandesEffectifs);
        this.commandesClientSvc.announceSelectedTypeEffectif(this.typeEffectifSelected);
        this.printEffectifService.announceHaveDataToPrint(!this.utils.isNullOrEmpty(this.viewCommandesEffectifs));
      } else {
        this.viewCommandesEffectifs = null;
        this.commandesClientSvc.announceViewCommandesEffectif(this.viewCommandesEffectifs);
      }
      this.loadingVisible = false;
      this.commandesClientSvc.announceLoadingView(this.loadingVisible);
    });
  }

  /**
   * Méthode qui renvoie la vue demandée par l'utilisateur par rapport à ses choix (la date sélectionnée, le point de départ,
   * le second point d'entrée, et l'identifiant sélectionné par rapport au point de départ)
   */
  getViewEffectifCommandeClient = () => {
    this.viewCommandesEffectifs = null;
    this.loadViewTrigger$.next();
  }

  /**
   * Méthode utilisée lorsque l'utilisateur change de type d'effectif
   */
  changeTypeEffectif = () => {
    this.saveEffectivesCommandesClients(true).then();
  };

  changeTypeEffectifSource = $event => {
    this.modesFiltered = this.modes.filter(mode => mode.value !== $event.value);
    this.typesEffectifTarget = [this.modesFiltered[0].value];
    return this.typeEffectifSource = $event.value;
  };

  changeTypeEffectifTarget = $event => {
    return this.typesEffectifTarget = $event.value;
  };

  openDialogPrintCoutRevientPlat = () => {
    this.saveEffectivesCommandesClients();

    this.printCrpService.announceDisplayDialogPrintCoutRevientPlat(true);
  }

  openDialogPrintEffectifMenu = () => {
    this.saveEffectivesCommandesClients();

    const pes = new PrintEffectifSupplier(this.selectedPlc, this.selectedDate, this.viewCommandesEffectifs, true, false,
      this.week.weekMonday, this.week.weekSunday, this.startPoint, this.endPoint, this.idSelected, this.codeSelected);
    this.printEffectifService.announceDisplayDialogPrintEffectif(pes);
  };

  openDialogPrintEffectifDetailsMenu = () => {
    this.saveEffectivesCommandesClients();

    const pes = new PrintEffectifSupplier(this.selectedPlc, this.selectedDate, this.viewCommandesEffectifs, true, true,
      this.week.weekMonday, this.week.weekSunday, this.startPoint, this.endPoint, this.idSelected, this.codeSelected);
    this.printEffectifService.announceDisplayDialogPrintEffectif(pes);
  };

  openDialogPrintEffectifMenuTotaux = (): void => {
    this.saveEffectivesCommandesClients();

    this.printEffectifService.announceDisplayDialogPrintEffectifTotaux({
      dates: this.selectedDate
    });
  }

  /**
   * Subscription pour initialiser le menu proposé aux utilisateur pour imprimer certaines données concernant
   * le planning des effectifs
   */
  initHaveDataToPrintSubscription = () => {
    this.subHaveDataToPrint = this.printEffectifService.haveDataToPrint$.subscribe((hasData: boolean) => {
      this.itemEffectifs.disabled = !hasData;
      this.itemEffectifsDetails.disabled = !hasData;

      this.itemsPrintMenu = [this.itemCr, this.itemEffectifs, this.itemEffectifsTotaux, this.itemEffectifsDetails];
    });
  };

  /**
   * Subscription qui reçoit les informations nécessaires pour modifier un effectif ou un taux de prise, par
   * rapport à une ligne ou à un détail
   */
  saveEffectifsCommandesClientsSubscription = () => {
    this.subSaveEffectivesCommandesClientsFromRow =
      this.commandesClientSvc.saveEffectifsCommandesClientsFromRow$
        .subscribe((cells: RowEffectifsCommandesClientDTO[]) => {
          this.commandesClientSvc.saveEffectifsCommandesClients(this.idSelected, this.duplicateStartPoint, this.codeSelected,
            this.endPoint, this.duplicateViewCommandesEffectifs, cells, this.detailsUpdated, null, null)
            .subscribe(response => {
              if (!this.utils.isNullOrEmpty(response) && !this.utils.isNullOrEmpty(response.one)) {
                this.commandesClientSvc.announceRefreshViewCommandesEffectif();
              } else {
                this.viewCommandesEffectifs = null;
                this.commandesClientSvc.announceViewCommandesEffectif(null);
              }
            })
        });

    this.subSaveEffectivesCommandesClientsFromDetail =
      this.commandesClientSvc.saveEffectifsCommandesClientsFromDetail$.subscribe((item: [boolean, boolean, DetailEffectifCommandeClientDTO[]]) => {
        if (this.codeSelected && this.viewCommandesEffectifs) {
          this.commandesClientSvc.saveEffectifsCommandesClients(this.idSelected, this.startPoint, this.codeSelected,
            this.endPoint, this.duplicateViewCommandesEffectifs, this.rowsUpdated, item[2], item[0], item[1])
            .subscribe(response => {
              if (!this.utils.isNullOrEmpty(response) && !this.utils.isNullOrEmpty(response.one)) {
                if (item[0] || item[1]) {
                  this.loadViewSilently();
                } else {
                  this.commandesClientSvc.announceRefreshViewCommandesEffectif();
                }
              } else {
                this.viewCommandesEffectifs = null;
                this.commandesClientSvc.announceViewCommandesEffectif(null);
              }
            })
        }
      })
  }

  selectPlcForDuplication = ($event: any) => this.selectedPlcListForDuplication = $event.value;

  /**
   * Méthode utilisée lorsqu'on sélectionne un point de départ dans la liste de sélection
   */
  selectStartPoint = async ($event: any) => {
    this.commandesClientSvc.announceLoadingView(true);
    this.selectedPlc = $event;

    if (this.viewCommandesEffectifs != null) {
      await this.saveEffectivesCommandesClients(false, true);
      this.commandesClientSvc.announceDetailsEffectifCommandeClient(null);
      this.viewCommandesEffectifs = null;
      this.selectedCell = null;
    }

    this.declareCodeSelected();
    this.commandesClientSvc.announceMenuMonthChange(null, false);

    if (!$event) {
      this.commandesClientSvc.announceLoadingView(false);
    }
  }

  /**
   * Méthode utilisée lorsqu'on modifie le point de départ, qui permet de tout réinitialiser
   * en attendant que l'utilisateur sélectionne un point de départ dans la nouvelle liste de
   * sélection
   */
  updateStartPoint = () => {
    this.saveEffectivesCommandesClients();

    this.selectedPlc = null;
    this.selectedRepas = null;
    this.selectedPrestation = null;
    this.codeSelected = null;
    this.endPoint = null;

    this.initEndPoint();

    this.commandesClientSvc.announceMenuMonthChange(null, false);

    this.commandesClientSvc.announceViewCommandesEffectif(null);

    this.commandesClientSvc.announceDetailsEffectifCommandeClient(null);
  }

  /**
   * Méthode qui initialise les seconds points d'entrées par rapport au point de départ sélectionné
   * par l'utilisateur
   */
  initEndPoint = () => {
    switch (this.startPoint) {
      case StartPointCommandesClientsEnum.PLC:
        if (!this.endPoint) {
          this.endPoint = StartPointCommandesClientsEnum.REPAS;
          this.commandesClientSvc.announceEndPointUpdated(this.endPoint);
        }
        this.endPointPanel = [StartPointCommandesClientsEnum.REPAS, StartPointCommandesClientsEnum.PRESTATION];
        break;
      case StartPointCommandesClientsEnum.REPAS:
        if (!this.endPoint) {
          this.endPoint = StartPointCommandesClientsEnum.PLC;
          this.commandesClientSvc.announceEndPointUpdated(this.endPoint);
        }
        this.endPointPanel = [StartPointCommandesClientsEnum.PLC, StartPointCommandesClientsEnum.PRESTATION];
        break;
      case StartPointCommandesClientsEnum.PRESTATION:
        if (!this.endPoint) {
          this.endPoint = StartPointCommandesClientsEnum.PLC;
          this.commandesClientSvc.announceEndPointUpdated(this.endPoint);
        }
        this.endPointPanel = [StartPointCommandesClientsEnum.PLC, StartPointCommandesClientsEnum.REPAS];
        break;
    }
  }

  /**
   * Méthode qui modifie la vue selon le choix de l'utilisateur en ce qui concerne le second point d'entrée
   */
  updateEndPoint = ($event: any) => {
    this.commandesClientSvc.announceLoadingView(true);
    //this.selectedCell = null;
    this.commandesClientSvc.announceDetailsEffectifCommandeClient(null);
    if (this.detailsUpdated.length == 0 && this.rowsUpdated.length == 0) {
      this.endPoint = $event.itemData;
      this.commandesClientSvc.announceEndPointUpdated(this.endPoint);
      this.getViewEffectifCommandeClient();
    } else {
      this.saveEffectivesCommandesClients(true).then(() => {
        this.endPoint = $event.itemData;
        this.viewCommandesEffectifs = null;
        this.commandesClientSvc.announceDetailsEffectifCommandeClient(null);
        this.commandesClientSvc.announceEndPointUpdated(this.endPoint);
        this.getViewEffectifCommandeClient();
      });
    }
  }

  /**
   * Méthode utilisée lorsque l'utilisateur sélectionne une date
   */
  updateDatesBySelection = ($event: any) => {
    this.commandesClientSvc.announceMenuMonthChange(null, false);

    this.viewCommandesEffectifs = null;
    this.selectedCell = null;
    this.commandesClientSvc.announceViewCommandesEffectif(null);
    this.commandesClientSvc.announceDetailsEffectifCommandeClient(null);

    if ($event) this.selectedDate = $event.value;

    this.week = {
      weekInYear: this.utils.getWeek(this.selectedDate),
      weekMonday: this.utils.getFirstDayOfWeek(this.selectedDate),
      weekSunday: this.utils.getLastDayOfWeek(this.selectedDate),
      weekYear: this.selectedDate.getFullYear()
    };

    this.saveEffectivesCommandesClients();

    this.cd.detectChanges();
  }

  /**
   * Méthode utilisée lorsque l'utilisateur ne sélectionne pas de date
   */
  updtateDatesByClickOutside = () => this.commandesClientSvc.announceMenuMonthChange(null, true);

  /**
   * Méthode utilisée lorsque l'utilisateur change de mois sur le calendrier proposé pour
   * sélectionner une date
   */
  updateDatesByMonth = ($event: any) => this.commandesClientSvc.announceMenuMonthChange($event, false);

  /**
   * Méthode qui initialise les données du menu
   */
  initMenu = (response: DatesDetailsFromMenuDTO, event: any, clickOutside: boolean) => {
    this.datesDetailsFromMenu = response;
    this.disabledDays = this.utils.getDisabledDays(response.joursDisponibles);

    this.datesSaisieEffectifs = response.datesSaisieEffectifs;
    this.datesCreationMenus = response.datesCreationMenus;
    this.datesFacturation = response.datesFacturation;
    this.dateMin = response.dateMin;

    this.dateMin = this.utils.convertNumberDateToDate(this.dateMin);

    if (this.datesSaisieEffectifs?.length) {
      this.datesSaisieEffectifs = this.datesSaisieEffectifs.map(item => this.utils.convertNumberDateToDate(item));
    }

    if (this.datesCreationMenus?.length)
      this.datesCreationMenus = this.datesCreationMenus.map(item => this.utils.convertNumberDateToDate(item));

    if (this.datesFacturation?.length)
      this.datesFacturation = this.datesFacturation.map(item => this.utils.convertNumberDateToDate(item));

    if (!event) {
      this.commandesClientSvc.announceDatesDetailsFromMenu(response);

      if (!clickOutside) {
        this.initCols();
        this.commandesClientSvc.announceRefreshViewCommandesEffectif();
      }
    }
  };

  /**
   * Méthode qui permet de formatter la date sur le calendrier proposé à l'utilisateur
   */
  getWeekLabel = (week: Week): string => this.utils.getWeek(week.weekMonday) + ' ' + this.datePipe.transform(week.weekMonday, 'dd/MM/yyyy')
    + ' au ' + this.datePipe.transform(week.weekSunday, 'dd/MM/yyyy');

  /**
   * Méthode qui permet de récupérer les cellules 'row' modifiées et de les stocker avant de les sauvegarder
   */
  rowUpdatedSubscription = () => {
    this.subRowUpdated = this.commandesClientSvc.rowUpdated$.subscribe((cell: RowEffectifsCommandesClientDTO) => {
      cell = this.updateDetails(cell);

      let idxItemFound: number = this.rowsUpdated.findIndex(c => c.cmcrPlcDate?.id === cell.cmcrPlcDate?.id);
      if (idxItemFound > -1)
        this.rowsUpdated[idxItemFound] = cell;
      else
        this.rowsUpdated.push(Object.assign({}, cell));
    })
  }

  /**
   * Méthode qui permet de récupérer les cellules 'detail' modifiées et de les stocker avant de les sauvegarder
   */
  detailUpdatedSubscription = () => {
    this.subDetailUpdated = this.commandesClientSvc.detailUpdated$.subscribe((cell: DetailEffectifCommandeClientDTO) : void => {
      let idxItemFound: number = this.detailsUpdated.findIndex((c: DetailEffectifCommandeClientDTO): boolean =>
        (cell.gcomCmcrPlcDateId != null && c.gcomCmcrPlcDateId === cell.gcomCmcrPlcDateId) ||
        (cell.gcomCmcrPlcDateId == null && c.mcPlc?.id === cell.mcPlc?.id));
      if (idxItemFound > -1)
        this.detailsUpdated[idxItemFound] = cell;
      else
        this.detailsUpdated.push(Object.assign({}, cell));
    })
  }

  /**
   * Méthode qui modifier les détails d'une cellule suite à la modification de l'effectif de celle-ci
   */
  updateDetails = (cell: RowEffectifsCommandesClientDTO): RowEffectifsCommandesClientDTO => {
    const effectifByType: { [key in TypeEffectifEnum]: number } = {
      [TypeEffectifEnum.PREVISIONNEL]: cell.effectifPrevisionnel,
      [TypeEffectifEnum.FABRICATION]: cell.effectifFabrication,
      [TypeEffectifEnum.FACTURATION]: cell.effectifFacturation,
    };

    (Object.values(TypeEffectifEnum) as TypeEffectifEnum[]).forEach(typeEffectif => {
      const effectif = effectifByType[typeEffectif];

      const activeDetails = cell.details.filter(d =>
        d.typeEffectif === typeEffectif && d.plat != null && d.tauxPrise != null);

      const groups = new Map<number, DetailEffectifCommandeClientDTO[]>();
      activeDetails.forEach(d => {
        const id = d.composanteRepas.id;
        if (!groups.has(id)) groups.set(id, []);
        groups.get(id).push(d);
      });

      groups.forEach(groupDetails => {
        const totalTdp = groupDetails.reduce((sum, d) => sum + d.tauxPrise, 0);

        groupDetails.forEach(d => {
          const val = d.tauxPrise * effectif / 100;
          d.effectifPrevu = val > 0 && val < 1 ? 1 : Math.floor(val);
          d.arrondiEffectifPrevu = false;
        });

        if (totalTdp >= 100) {
          const total = groupDetails.reduce((sum, d) => sum + d.effectifPrevu, 0);
          const reliquat = effectif - total;
          if (reliquat > 0) {
            const firstChoice = groupDetails.find(d => d.composanteRepas?.libelle?.endsWith('1'));
            if (firstChoice) {
              firstChoice.effectifPrevu += reliquat;
              firstChoice.arrondiEffectifPrevu = true;
            }
          }
        }
      });

      cell.details
        .filter(d => d.typeEffectif === typeEffectif && (d.plat == null || d.tauxPrise == null))
        .forEach(d => { d.effectifPrevu = 0; d.arrondiEffectifPrevu = false; });
    });

    return cell;
  }

  /**
   * Méthode qui permet de lancer la sauvegarde des effectifs
   */
  saveEffectivesCommandesClients = (withRefreshData: boolean = false, skipRefresh: boolean = false): Promise<void> => {
    return new Promise((resolve, reject) => {
      if (this.rowsUpdated.length) {
        const rows = [...this.rowsUpdated];
        this.rowsUpdated = [];
        this.duplicateStartPoint = this.startPoint;

        this.commandesClientSvc
          .saveEffectifsCommandesClients(
            this.idSelected,
            this.duplicateStartPoint,
            this.codeSelected,
            this.endPoint,
            this.duplicateViewCommandesEffectifs,
            rows,
            this.detailsUpdated,
            null,
            null
          )
          .subscribe({
            next: (response) => {
              if (!this.utils.isNullOrEmpty(response) && !this.utils.isNullOrEmpty(response.one)) {
                if (!skipRefresh) this.getViewEffectifCommandeClient();
              } else {
                this.viewCommandesEffectifs = null;
                this.commandesClientSvc.announceViewCommandesEffectif(null);
              }
              resolve();
            },
            error: (err) => reject(err),
          });
      } else if (this.detailsUpdated.length) {
        const details = [...this.detailsUpdated];
        this.detailsUpdated = [];
        this.duplicateStartPoint = this.startPoint;

        if (this.codeSelected && this.viewCommandesEffectifs) {
          this.commandesClientSvc
            .saveEffectifsCommandesClients(
              this.idSelected,
              this.startPoint,
              this.codeSelected,
              this.endPoint,
              this.duplicateViewCommandesEffectifs,
              this.rowsUpdated,
              details,
              null,
              null
            )
            .subscribe({
              next: (response) => {
                if (!this.utils.isNullOrEmpty(response) && !this.utils.isNullOrEmpty(response.one)) {
                  if (!skipRefresh) this.getViewEffectifCommandeClient();
                } else {
                  this.viewCommandesEffectifs = null;
                  this.commandesClientSvc.announceViewCommandesEffectif(null);
                }
                resolve();
              },
              error: (err) => reject(err),
            });
        } else {
          resolve();
        }
      } else {
        if (withRefreshData && !skipRefresh) {
          this.getViewEffectifCommandeClient();
        }
        resolve();
      }
    });
  };

  inactivityTime = () => {
    const timeout: number = 60000;

    const resetTimer = () => {
      clearTimeout(this.inactivityTimer);
      this.inactivityTimer = setTimeout(() => this.saveEffectivesCommandesClients(true), timeout);
    };

    this.mouseMoveHandler = resetTimer;
    this.keyPressHandler = resetTimer;

    document.addEventListener("mousemove", this.mouseMoveHandler);
    document.addEventListener("keypress", this.keyPressHandler);

    resetTimer();
  }

  convertToDate = (date: string) => new Date(date);
}
